import React from 'react';

export const CertificatePreviewStep = ({
  previewUrl = '',
  loading = false,
  error = '',
  mode = 'individual',
  selectedStudentLabel = '',
  recipientCount = 0,
  students = [],
  certificateNames = {},
  grades = {},
  canPreview = false,
  canConfirm = false,
  onNameChange = () => {},
  onGradeChange = () => {},
  onRemoveRecipient = () => {},
  onConfirm,
}) => {
  const hasPreview = Boolean(previewUrl) && !loading;

  return (
    <section
      className="certificate-wizard-card certificate-preview-step"
      aria-labelledby="certificate-preview-step-title"
    >
      <div className="certificate-wizard-card-heading">
        <span aria-hidden="true">4</span>
        <div>
          <h2 id="certificate-preview-step-title">Revisión y edición</h2>
          <p>
            Verifica y corrige los datos que aparecerán en cada constancia.
          </p>
        </div>
      </div>

      {students.length > 0 && (
        <div className="certificate-review-table-wrapper">
          <table className="certificate-review-table">
            <thead>
              <tr>
                <th scope="col">Nombre en la constancia</th>
                <th scope="col">Matrícula</th>
                <th scope="col">Calificación</th>
                <th scope="col">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {students.map((student) => {
                const idStudent = String(student.id_alumno);
                const displayName =
                  certificateNames[idStudent] ?? student.nombre_alumno ?? '';
                return (
                  <tr key={idStudent}>
                    <td>
                      <input
                        aria-label={`Nombre en la constancia de ${student.nombre_alumno}`}
                        type="text"
                        maxLength="255"
                        value={displayName}
                        onChange={(event) =>
                          onNameChange(idStudent, event.target.value)
                        }
                        required
                      />
                    </td>
                    <td>{student.matricula_alumno || '—'}</td>
                    <td>
                      <input
                        aria-label={`Calificación final de ${student.nombre_alumno}`}
                        type="number"
                        min="0"
                        max="100"
                        step="0.01"
                        inputMode="decimal"
                        value={grades[idStudent] ?? ''}
                        onChange={(event) =>
                          onGradeChange(idStudent, event.target.value)
                        }
                        required
                      />
                    </td>
                    <td>
                      {mode !== 'individual' && students.length > 1 ? (
                        <button
                          type="button"
                          className="danger-link"
                          onClick={() => onRemoveRecipient(idStudent)}
                        >
                          Quitar
                        </button>
                      ) : (
                        <span>—</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {loading && (
        <p
          className="certificate-preview-state"
          role="status"
          aria-live="polite"
        >
          Generando vista previa...
        </p>
      )}

      {error && (
        <p className="certificate-wizard-status" role="alert">
          {error}
        </p>
      )}

      {hasPreview && (
        <>
          <div className="certificate-preview-summary">
            {mode !== 'individual' ? (
              <strong>Se generarán {recipientCount} constancias</strong>
            ) : (
              <>
                <p>
                  <strong>Alumno seleccionado:</strong>{' '}
                  <span>{selectedStudentLabel}</span>
                </p>
                <strong>Se generará 1 constancia</strong>
              </>
            )}
          </div>
          <iframe
            className="certificate-preview-frame"
            title="Vista previa de la constancia"
            src={previewUrl}
          />
          <p className="certificate-preview-qr-note" role="note">
            Esta vista previa no incluye QR. Al confirmar se crearán los PDF
            definitivos con QR para validación interna, todavía invisibles para
            los estudiantes.
          </p>
        </>
      )}

      <div className="certificate-wizard-actions">
        <button
          type="submit"
          className="secondary"
          disabled={!canPreview || loading}
        >
          {hasPreview ? 'Actualizar vista previa' : 'Generar vista previa'}
        </button>
        {hasPreview && (
          <a
            className="secondary"
            href={previewUrl}
            download="vista-previa-constancia.pdf"
          >
            Descargar vista previa
          </a>
        )}
        <button type="button" disabled={!canConfirm} onClick={onConfirm}>
          Generar archivos definitivos con QR
        </button>
      </div>
    </section>
  );
};
